import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';

export default class SubscriptionCenterIndexRoute extends Route {
  redirect(_model: null, transition: Transition) {
    if (transition.to?.name === 'workspace-settings.subscription_center.index') {
      this.router.transitionTo('workspace-settings.subscription_center.topics');
    }
  }
}
